import React from 'react';
import './LeadGeneration.css';
import leadGenImage from '../assets/lead genrator.png';

const LeadGeneration = () => {
  return (
    <section className="lead-generation-section">
      <div className="container lead-gen-content">
        <div className="lead-gen-text">
          <h5>LEAD GENERATION</h5>
          <h2>Target. Capture. Convert.</h2>
          <p>
            At <strong>JN IT Digital Solutions</strong>, we provide performance-driven lead generation strategies that bring in quality prospects to grow your business.
          </p>
          <p>
            From identifying your ideal audience to nurturing leads across platforms, our approach blends content, paid ads, SEO, and smart automation to deliver leads that convert.
          </p>
          <ul>
            <li>✔ Targeted campaigns on Google, Meta, LinkedIn</li>
            <li>✔ Conversion-optimized landing pages</li>
            <li>✔ CRM & email follow-up integration</li>
          </ul>
          <p>
            Whether B2B or B2C, we ensure your sales funnel stays full — with qualified, engaged leads ready to do business.
          </p>
          <button className="get-started-btn">Get Started</button>
        </div>
        <div className="lead-gen-image-container">
          <img src={leadGenImage} alt="Lead Generation" />
        </div>
      </div>
    </section>
  );
};

export default LeadGeneration;
